<template>
  <div>
    <v-toolbar dark color="primary">
      <v-toolbar-title>
        <div class="d-flex flex-column">
          <strong>وبکارت</strong>
          <small class="text-muted text-small">گزارش کارکرد روزانه پرسنل</small>
        </div>
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <div id="viewer" dir="ltr"></div>
  </div>
</template>

<script>
import reportFile from "../../assets/reports/personelDailyWork.mrt";
import reportTexts from "../../assets/js/reports";
import EosUtils from "../../utils/EosUtils";
import ResultType from "../../model/ResultType";

export default {
  data() {
    return {
      visible: false,
      dataLoaded: false,
      variables: null,
      list: null,
      totalPersonDayWork: null,
    };
  },
  mounted() {
    this.loadPage();
  },
  watch: {
    dataLoaded(newVal) {
      if (newVal) {
        this.showReport();
      }
    },
  },
  methods: {
    loadPage() {
      var args = this.$route.query;
      var perno = this.$store.state.auth.auth.username;
      var beginDate = args.BD;
      var endDate = args.ED;
      var dedicatedPerno = args.dp;

      this.ValidateQueryInputs(perno, beginDate, endDate, dedicatedPerno);
      this.getData(perno, beginDate, endDate, dedicatedPerno);
    },
    ValidateQueryInputs(perno, beginDate, endDate, dedicatedPerno) {
      if (!perno) {
        this.transferPage();
      }
      if (!dedicatedPerno) {
        this.transferPage();
      }
      if (!beginDate) {
        this.transferPage();
      }
      if (!endDate) {
        this.transferPage();
      }
    },
    transferPage() {
      //todo : error wrong page
    },
    async getData(perno, beginDate, endDate, dedicatedPerno) {
      var moment = require("jalali-moment");

      var variables = {};
      if (EosUtils.isWebKartAdmin()) {
        variables.perno = "-";
        variables.personName = "مدير وب کارت";
      } else {
        variables.perno = perno;
        variables.personName =
          this.$store.state.personel.personelDetail.PersonName;
      }

      variables.beginDate = beginDate;
      variables.endDate = endDate;
      variables.timeNow = moment().locale("fa").format("YYYY/MM/DD HH:mm");
      variables.companyName = "CompanyName";

      if (dedicatedPerno == perno) {
        variables.dedicatePersonName = variables.personName;
        variables.dedicatePerson = variables.perno;
      } else {
        variables.dedicatePersonName = "";
        variables.dedicatePerson = dedicatedPerno;
        var EosPersonelDetailResponse = await this.$store.dispatch(
          "EosPersonelDetail",
          { perno: dedicatedPerno }
        );
        if (EosPersonelDetailResponse.type === ResultType.success) {
          var personelDetails = EosPersonelDetailResponse.data;
          variables.dedicatePersonName = personelDetails.PersonName;
        }
      }

      var GetCustomerNameResponse = await this.$store.dispatch(
        "lock/GetCustomerName"
      );
      if (GetCustomerNameResponse.type == ResultType.success) {
        variables.customerName = GetCustomerNameResponse.data;
      }

      this.variables = variables;

      this.getList(beginDate, endDate, dedicatedPerno);
    },
    getList(beginDate, endDate, dedicatedPerno) {
      const params = new URLSearchParams();
      params.append("beginDate", beginDate);
      params.append("endDate", endDate);
      params.append("perno", dedicatedPerno);

      this.$store
        .dispatch("getPersonDayWorksTotal", { params })
        .then((result) => {
          ////console.log(result);
          if (result.type === "success") {
            this.list = result.data.WebPersonDayWorks.WebWorkDayList;
            this.totalPersonDayWork = result.data.TotallPersonDayWork;
            this.dataLoaded = true;
          }
        });
    },
    showReport() {
      window.Stimulsoft.Base.StiLicense.key = reportTexts.getStimulKey();
      let options = new window.Stimulsoft.Viewer.StiViewerOptions();
      /*options.appearance.fullScreenMode = true;
      options.toolbar.displayMode =
        window.Stimulsoft.Viewer.StiToolbarDisplayMode.Separated;*/
      var viewer = new window.Stimulsoft.Viewer.StiViewer(
        options,
        "StiViewer",
        false
      );

      let report = window.Stimulsoft.Report.StiReport.createNewReport();
      report.load(reportFile);

      report.dictionary.variables.getByName("FromDate").valueObject =
        this.variables.beginDate;
      report.dictionary.variables.getByName("ToDate").valueObject =
        this.variables.endDate;
      report.dictionary.variables.getByName("ReportDate").valueObject =
        this.variables.timeNow;
      report.dictionary.variables.getByName("CompanyName").valueObject =
        this.variables.customerName;
      report.dictionary.variables.getByName("dedicatePerson").valueObject =
        this.variables.dedicatePerson;
      report.dictionary.variables.getByName("dedicatePersonName").valueObject =
        this.variables.dedicatePersonName;
      report.dictionary.variables.getByName("Perno").valueObject =
        this.variables.perno;
      report.dictionary.variables.getByName("PersonName").valueObject =
        this.variables.personName;

      //totalPersonDayWork
      report.dictionary.variables.getByName("SelectedDay").valueObject =
        this.totalPersonDayWork.SelectedDay;
      report.dictionary.variables.getByName("TotalWork").valueObject =
        this.totalPersonDayWork.TotalWork;
      report.dictionary.variables.getByName("TotalKasrKar").valueObject =
        this.totalPersonDayWork.TotalKasrKar;
      report.dictionary.variables.getByName("TotalEzafeKar").valueObject =
        this.totalPersonDayWork.TotalEzafeKar;
      report.dictionary.variables.getByName("TotalMorakhasi").valueObject =
        this.totalPersonDayWork.TotalMorakhasi;
      report.dictionary.variables.getByName("TotalMission").valueObject =
        this.totalPersonDayWork.TotalMission;

      report.regData("d1", "d1", this.list);

      viewer.report = report;
      viewer.renderHtml("viewer");
    },
  },
};
</script>

<style>
</style>